import { RootAppState } from 'store/configureStore'

export const projectSellingPartySelector = (state: RootAppState) => {
  return state.project.activeProject?.sellingParty
}


